export const SEARCH_FOR_CONTACT_POST = 'mac/FETCH_SEARCH_FOR_CONTACT_POST';
